import { Clock, Wrench, HandCoins, FileText } from "lucide-react";
import { PHONE_TEL } from "@/lib/api";

const BENEFITS = [
  { icon: Clock, t: "Close in 7–21 days", d: "Not months. No showings, no open houses, no waiting for a buyer's financing." },
  { icon: Wrench, t: "Zero repairs required", d: "Cracked foundation? Old roof? Tenants in place? Doesn't matter. We buy as-is." },
  { icon: HandCoins, t: "No agent commissions", d: "Keep the 6% agents would take. Our cash offers are net to you — no surprises." },
  { icon: FileText, t: "No fees or hidden costs", d: "No junk fees, no closing costs on your side, no inspection contingencies." },
];

export default function SellFast() {
  return (
    <section
      id="sell-fast"
      data-testid="sell-fast-section"
      className="py-20 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative order-2 lg:order-1">
          <div className="relative rounded-lg overflow-hidden border border-[#E5E3DB] shadow-[0_30px_60px_rgba(11,27,61,0.15)]">
            <img
              src="https://images.unsplash.com/photo-1762810981576-1b07f76af9d2"
              alt="Modern home exterior"
              className="w-full h-[460px] object-cover"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-lg p-5 border border-white">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#2C5545] mb-1">Typical offer</div>
              <div className="font-display text-2xl text-[#0B1B3D]">Cash in hand in under 21 days</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="mb-4">
            <span className="gold-rule" />
            <span className="text-xs uppercase tracking-[0.24em] text-[#2C5545] font-medium">
              Sell Your House Fast
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B1B3D] leading-tight mb-5">
            Skip the listings. Skip the wait. <em className="font-medium text-[#C5A059] not-italic">Sell on your terms.</em>
          </h2>
          <p className="text-[#64748B] leading-relaxed mb-8">
            Whether you're facing job relocation, inheritance headaches, a divorce,
            damaged property, or you simply want out — our vetted investor
            network makes a fair cash offer within 24 hours. Zero fees. Zero repairs. Zero pressure.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            {BENEFITS.map((b, i) => (
              <div
                key={i}
                data-testid={`sell-fast-benefit-${i}`}
                className="flex gap-3 rounded-lg bg-white p-4 border border-[#E5E3DB]"
              >
                <div className="h-10 w-10 rounded-md bg-[#2C5545]/10 flex items-center justify-center shrink-0">
                  <b.icon className="h-5 w-5 text-[#2C5545]" />
                </div>
                <div>
                  <div className="font-medium text-[#0B1B3D]">{b.t}</div>
                  <div className="text-sm text-[#64748B] leading-relaxed">{b.d}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="#top"
              data-testid="sell-fast-form-cta"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-lg bg-[#C5A059] hover:bg-[#B38F4E] text-[#0B1B3D] font-semibold transition-all shadow-md hover:shadow-lg"
            >
              Get my cash offer
            </a>
            <a
              href={`sms:${PHONE_TEL}`}
              data-testid="sell-fast-call-cta"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-lg border border-[#0B1B3D] text-[#0B1B3D] hover:bg-[#F3F2EE] font-medium transition-all"
            >
              Or text an advocate
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
